import { defineMessages } from 'react-intl'

export default defineMessages({
  errorTitle: {
    id: 'containers.PublicSchedulingPollPage.errorTitle',
    defaultMessage: 'Error',
  },
  errorRequestNotFound: {
    id: 'containers.PublicSchedulingPollPage.errorRequestNotFound',
    defaultMessage: 'Request not found',
  },
  pollClosedTitle: {
    id: 'containers.PublicSchedulingPollPage.pollClosedTitle',
    defaultMessage: 'Poll Closed',
  },
  pollClosedMessage: {
    id: 'containers.PublicSchedulingPollPage.pollClosedMessage',
    defaultMessage: 'This scheduling poll is no longer accepting responses.',
  },
  thankYouTitle: {
    id: 'containers.PublicSchedulingPollPage.thankYouTitle',
    defaultMessage: 'Thank You!',
  },
  availabilityRecorded: {
    id: 'containers.PublicSchedulingPollPage.availabilityRecorded',
    defaultMessage: 'Your availability has been recorded for "{title}".',
  },
  emailNotification: {
    id: 'containers.PublicSchedulingPollPage.emailNotification',
    defaultMessage: "You'll receive an email once a final time is selected.",
  },
  timesShownIn: {
    id: 'containers.PublicSchedulingPollPage.timesShownIn',
    defaultMessage: 'Times shown in {timezone}',
  },
  peopleResponded: {
    id: 'containers.PublicSchedulingPollPage.peopleResponded',
    defaultMessage: '{count, plural, one {# person has} other {# people have}} already responded',
  },
  yourInformation: {
    id: 'containers.PublicSchedulingPollPage.yourInformation',
    defaultMessage: 'Your Information',
  },
  yourName: {
    id: 'containers.PublicSchedulingPollPage.yourName',
    defaultMessage: 'Your name',
  },
  yourEmail: {
    id: 'containers.PublicSchedulingPollPage.yourEmail',
    defaultMessage: 'Your Email',
  },
  emailNotificationHint: {
    id: 'containers.PublicSchedulingPollPage.emailNotificationHint',
    defaultMessage: "You'll receive a notification when a final time is selected",
  },
  selectAvailability: {
    id: 'containers.PublicSchedulingPollPage.selectAvailability',
    defaultMessage: 'Select Your Availability',
  },
  selectAvailabilityHint: {
    id: 'containers.PublicSchedulingPollPage.selectAvailabilityHint',
    defaultMessage: 'For each time option, indicate your availability',
  },
  available: {
    id: 'containers.PublicSchedulingPollPage.available',
    defaultMessage: 'Available',
  },
  maybe: {
    id: 'containers.PublicSchedulingPollPage.maybe',
    defaultMessage: 'Maybe',
  },
  unavailable: {
    id: 'containers.PublicSchedulingPollPage.unavailable',
    defaultMessage: 'Unavailable',
  },
  submitAvailability: {
    id: 'containers.PublicSchedulingPollPage.submitAvailability',
    defaultMessage: 'Submit My Availability',
  },
  submitting: {
    id: 'containers.PublicSchedulingPollPage.submitting',
    defaultMessage: 'Submitting...',
  },
  updateResponseHint: {
    id: 'containers.PublicSchedulingPollPage.updateResponseHint',
    defaultMessage: 'You can update your response later by using the same email address',
  },
  enterNameError: {
    id: 'containers.PublicSchedulingPollPage.enterNameError',
    defaultMessage: 'Please enter your name',
  },
  enterValidEmailError: {
    id: 'containers.PublicSchedulingPollPage.enterValidEmailError',
    defaultMessage: 'Please enter a valid email address',
  },
  responseSubmittedSuccess: {
    id: 'containers.PublicSchedulingPollPage.responseSubmittedSuccess',
    defaultMessage: 'Your response has been submitted!',
  },
  namePlaceholder: {
    id: 'containers.PublicSchedulingPollPage.namePlaceholder',
    defaultMessage: 'John Doe',
  },
  emailPlaceholder: {
    id: 'containers.PublicSchedulingPollPage.emailPlaceholder',
    defaultMessage: 'john@example.com',
  },
  submitResponseError: {
    id: 'containers.PublicSchedulingPollPage.submitResponseError',
    defaultMessage: 'Failed to submit response',
  },
})
